import apiClient from "./BaseService";

export default {
    callReadSharedPayslipsApi(payload) {
        // console.log("Service Payload ==>>", payload)
        payload.orgId = localStorage.orgId;
        if (localStorage._countryId != null)
            payload.countryId = localStorage._countryId;
        return apiClient.qooSquare.post("readSharedPayslips", payload);
    },
}